import { createFeatureSelector } from '@ngrx/store';
import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { QueryParamsModel } from '../../_base/crud';
import { CategoryDescription } from '../_models/category-description.model';
import {
  CategoryDescriptionActions,
  CategoryDescriptionActionTypes,
} from '../_actions/category-description.actions';

export interface CategoryDescriptionState extends EntityState<CategoryDescription> {
  listLoading: boolean;
  actionsloading: boolean;
  totalCount: number;
  lastCreatedCategoryDescriptionId: number;
  lastCreatedCategoryDescription: CategoryDescription;
  lastQuery: QueryParamsModel;
  error: any;
  latestSuccessfullAction: any;
  showInitWaitingMessage: boolean;
}

export const adapter: EntityAdapter<CategoryDescription> =
  createEntityAdapter<CategoryDescription>();

export const initialCategoryDescriptionState: CategoryDescriptionState = adapter.getInitialState({
  listLoading: false,
  actionsloading: false,
  totalCount: 0,
  error: null,
  latestSuccessfullAction: null,
  lastQuery: new QueryParamsModel({}),
  lastCreatedCategoryDescriptionId: undefined,
  lastCreatedCategoryDescription: undefined,
  showInitWaitingMessage: true,
});

export function CategoryDescriptionReducer(
  state = initialCategoryDescriptionState,
  action: CategoryDescriptionActions,
): CategoryDescriptionState {
  switch (action.type) {
    case CategoryDescriptionActionTypes.CategoryDescriptionPageToggleLoading:
      return {
        ...state,
        listLoading: action.payload.isLoading,
        lastCreatedCategoryDescriptionId: undefined,
      };
    case CategoryDescriptionActionTypes.CategoryDescriptionActionToggleLoading:
      return {
        ...state,
        actionsloading: action.payload.isLoading,
      };
    case CategoryDescriptionActionTypes.CategoryDescriptionDeleted:
      return adapter.removeOne(action.payload.id, state);
    case CategoryDescriptionActionTypes.CategoryDescriptionPageCancelled:
      return {
        ...state,
        listLoading: false,
        lastQuery: new QueryParamsModel({}),
      };
    case CategoryDescriptionActionTypes.CategoryDescriptionPageLoaded: {
      return adapter.addMany(action.payload.categoryDescription, {
        ...initialCategoryDescriptionState,
        totalCount: action.payload.totalCount,
        lastQuery: action.payload.page,
        showInitWaitingMessage: false,
        latestSuccessfullAction: state.latestSuccessfullAction,
        error: null,
      });
    }
    case CategoryDescriptionActionTypes.ThrowCategoryDescriptionError: {
      return {
        ...state,
        error: action.payload.error,
        actionsloading: false,
        listLoading: false,
      };
    }
    case CategoryDescriptionActionTypes.FireCategoryDescriptionSuccess: {
      return {
        ...state,
        latestSuccessfullAction: { action_type: action.payload.action_type },
        error: null,
      };
    }
    default:
      return state;
  }
}

export const getCategoryDescriptionState =
  createFeatureSelector<CategoryDescriptionState>('CategoryDescription');

export const { selectAll, selectEntities, selectIds, selectTotal } = adapter.getSelectors();
